import React, { useState, useCallback } from 'react'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { TextFieldProps } from '@material-ui/core/TextField'
import { Field, FieldProps } from 'formik'

import VisibilityIcon from '@material-ui/icons/Visibility'

import { TextField } from './styled'

const CommonPasswordField: React.FC<TextFieldProps> = ({ name, ...others }) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = useCallback(() => setShowPassword((s) => !s), [])

  const handleMouseDownPassword = useCallback((event) => {
    event.preventDefault()
  }, [])

  return (
    <Field name={name}>
      {({ field, meta: { error, touched } }: FieldProps) => (
        <TextField
          variant='outlined'
          margin='dense'
          error={Boolean(error) && touched}
          helperText={touched ? error : null}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  size='small'
                >
                  <VisibilityIcon fontSize='small' />
                </IconButton>
              </InputAdornment>
            ),
            notched: false
          }}
          InputLabelProps={{
            shrink: true,
            ...others?.InputLabelProps
          }}
          {...others}
          {...field}
        />
      )}
    </Field>
  )
}

export default CommonPasswordField
